module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "portfolio"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "project-types"
  }, _vm._l((_vm.types), function(type) {
    return _c('project-type', {
      attrs: {
        "type": type
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10 col-md-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.projects), function(project) {
    return _c('project-preview', {
      class: 'grid-item',
      attrs: {
        "project": project
      }
    })
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("portfolio")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fc66679e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Portfolio.vue
// module id = 594
// module chunks = 2